import { render, staticRenderFns } from "./memberList.vue?vue&type=template&id=85dd4b1a&scoped=true"
import script from "./memberList.vue?vue&type=script&lang=js"
export * from "./memberList.vue?vue&type=script&lang=js"
import style0 from "./memberList.vue?vue&type=style&index=0&id=85dd4b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dd4b1a",
  null
  
)

export default component.exports